export const Tags = Object.freeze({
  true: { label: 'metadata.status.mandatory', color: 'orange' },
  false: { label: 'metadata.status.optional', color: 'blue' }
})

export const getName = m => m.name
export const getMandatory = m => m.isMandatory

export class InternshipRequestMetadata {
  constructor ({ id, name, institution, isMandatory }) {
    this.id = id ?? -1
    this.institution = institution ?? null
    this.name = name ?? null
    this.isMandatory = isMandatory ?? false
  }

  toRequestBody () {
    return {
      name: this.name,
      institution: this.institution.id,
      isMandatory: this.isMandatory
    }
  }
}
